import qs from "qs";
import axios from "axios";
import { URL } from "../../../../constants/Constants";

/**
 * Inserta un nuevo tiempo de trabajo
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} usuario - Usuario que realiza la operación
 * @param {string} team - Equipo del usuario
 * @param {string} action - Acción realizada
 * @param {string} fechaEntrada - Fecha de entrada
 * @param {string} Tipo - Tipo de operación
 * @param {string} tipo_tiempo - Tipo de tiempo
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {number} cantidad - Cantidad
 * @returns {Promise<boolean>} true si se guardó correctamente, false en caso contrario
 */
export const insertNewTiempo = async (
  po,
  mo,
  usuario,
  team,
  action,
  fechaEntrada,
  Tipo,
  tipo_tiempo,
  currentScreenId,
  cantidad
) => {
  const newTime = {
    po: po,
    mo: mo,
    usuario: usuario,
    team: team,
    action: action,
    fechaEntrada: fechaEntrada,
    Tipo: Tipo,
    tipo_tiempo: tipo_tiempo,
    currentScreenId: currentScreenId,
    cantidad: cantidad,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Save");
      return true;
    } else {
      console.log("Error Save");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta un nuevo tiempo de mecanizado
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} usuario - Usuario que realiza la operación
 * @param {string} team - Equipo del usuario
 * @param {string} action - Acción realizada
 * @param {string} fechaEntrada - Fecha de entrada
 * @param {string} Tipo - Tipo de operación
 * @param {string} tipo_tiempo - Tipo de tiempo
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {number} cantidad - Cantidad
 * @returns {Promise<boolean>} true si se guardó correctamente, false en caso contrario
 */
export const insertNewTiempoMachining = async (
  po,
  mo,
  usuario,
  team,
  action,
  fechaEntrada,
  Tipo,
  tipo_tiempo,
  currentScreenId,
  cantidad
) => {
  const newTime = {
    po: po,
    mo: mo,
    usuario: usuario,
    team: team,
    action: action,
    fechaEntrada: fechaEntrada,
    Tipo: Tipo,
    tipo_tiempo: tipo_tiempo,
    query_type: currentScreenId,
    cantidad: cantidad,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Save");
      return true;
    } else {
      console.log("Error Save");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Actualiza el tiempo de mecanizado
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} action - Acción realizada
 * @param {string} fechaSalida - Fecha de salida
 * @param {number} peso - Peso
 * @param {string} type - Tipo de operación
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<boolean>} true si se guardó correctamente, false en caso contrario
 */
export const updateTiempoMezanizado = async (
  po,
  mo,
  action,
  fechaSalida,
  peso,
  type,
  currentScreenId
) => {
  const newTime = {
    po: po,
    mo: mo,
    action: action,
    fechaSalida: fechaSalida,
    peso: peso,
    Tipo: type,
    query_type: currentScreenId,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Save");
      return true;
    } else {
      console.log("Error Save");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Actualiza la visibilidad de líneas de mecanizado
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} action - Acción realizada
 * @param {string} type - Tipo de operación
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<boolean>} true si se guardó correctamente, false en caso contrario
 */
export const updateMachiningLineVisibility = async (
  po,
  mo,
  action,
  type,
  currentScreenId
) => {
  const newTime = {
    po: po,
    mo: mo,
    action: action,
    Tipo: type,
    query_type: currentScreenId,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Save");
      return true;
    } else {
      console.log("Error Save");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta nuevo tiempo de trabajo múltiple
 * @param {string} Trabajo - Tipo de trabajo
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} name - Nombre del usuario
 * @param {string} team - Equipo
 * @param {string} fechaIni - Fecha de inicio
 * @param {string} fechaFin - Fecha de fin
 * @param {string} proceso_tipo - Tipo de proceso
 * @param {string} tipo_tiempo - Tipo de tiempo
 * @param {number} cantidad_total - Cantidad total
 * @param {number} cantidad_ok - Cantidad OK
 * @param {number} cantidadIncidencia - Cantidad de incidencias
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} cod_team - Código del equipo
 * @param {string} codigo - Código
 * @param {number} segundos - Segundos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const InsertNewtimeMultiWork = async (
  Trabajo,
  po,
  mo,
  name,
  team,
  fechaIni,
  fechaFin,
  proceso_tipo,
  tipo_tiempo,
  cantidad_total,
  cantidad_ok,
  cantidadIncidencia,
  typeConnect,
  currentScreenId,
  cod_team,
  codigo,
  segundos
) => {
  let queryData;
  if (Trabajo === "PROCESOS") {
    queryData = {
      tipo_trabajo: Trabajo,
      po: po,
      mo: mo,
      usuario: name,
      team: team,
      fechaIni: fechaIni,
      fechaFin: fechaFin,
      proceso: proceso_tipo,
      tipo_tiempo: tipo_tiempo,
      cantidad_total: cantidad_total,
      cantidad_ok: cantidad_ok - cantidadIncidencia,
      cantidadIncidencia: cantidadIncidencia,
      action: typeConnect,
      query_type: currentScreenId,
      codigoProceso: cod_team,
      codigoIncidencia: codigo,
      tiempoSegundos: segundos,
    };
  } else {
    console.log("Error al enviar Multi Work");
    return;
  }

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene tiempos de MO
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} usuarioSelected - Usuario seleccionado
 * @returns {Promise<Array|false>} Tiempos de MO o false si hay error
 */
export const getTiemposMo = async (currentScreenId, typeConnect, usuarioSelected) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
    usuarioSelected: usuarioSelected,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta nuevo tiempo teórico
 * @param {string} query_param - Parámetro de consulta
 * @param {string} queryType - Tipo de consulta
 * @param {string} referencia - Referencia
 * @param {string} codigo - Código
 * @param {number} tiempo - Tiempo
 * @param {string} Metal - Metal
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertNewTheoreticalTime = async (
  query_param,
  queryType,
  referencia,
  codigo,
  tiempo,
  Metal
) => {
  const queryData = {
    query_param: query_param,
    query_type: queryType,
    codigo: codigo,
    referencia: referencia,
    tiempo: tiempo,
    Metal: Metal ? Metal : "",
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("nuevo tiempo no insertado");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta tiempo de trabajo
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} tipoCrono - Tipo de cronómetro
 * @param {string} data - Datos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const insertTimeTimeWork = async (
  currentScreenId,
  typeConnect,
  tipoCrono,
  data
) => {
  const userData = {
    query_type: currentScreenId,
    action: typeConnect,
    query_param: tipoCrono,
    info: data,
  };

  try {
    const response = await axios.post(URL, qs.stringify(userData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.error(
        "Error en la respuesta del servidor:",
        response.data.message
      );
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene tiempo transcurrido del servidor
 * @param {string} queryType - Tipo de consulta
 * @param {string} query_param - Parámetro de consulta
 * @param {string} mo - Manufacturing Order
 * @param {string} startDate - Fecha de inicio
 * @returns {Promise<number|null>} Tiempo transcurrido en minutos o null si hay error
 */
export const getElapsedTimeFromServer = async (queryType, query_param, mo, startDate) => {
  const queryData = {
    query_type: queryType,
    query_param: query_param,
    mo: mo,
    startDate: startDate,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "success" && response.data.elapsed_time) {
      console.log(
        "Tiempo del servidor:",
        response.data.elapsed_time,
        "minutos"
      );
      return response.data.elapsed_time;
    } else {
      console.warn(
        "Error en la respuesta del servidor:",
        response.data.message
      );
      return null;
    }
  } catch (error) {
    console.error("Error al conectar con el servidor:", error);
    return null;
  }
};

/**
 * Consulta tiempos
 * @param {string} screen - Pantalla
 * @param {string} mo - Manufacturing Order
 * @param {string} po - Purchase Order
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const queryTimes = async (screen, mo, po) => {
  const data = {
    screen: screen,
    mo: mo,
    po: po,
    query_type: "",
  };

  try {
    const response = await axios.post(URL, qs.stringify(data));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Error consulta tiempos");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Actualiza tiempo temporal
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} formattedTime - Tiempo formateado
 * @param {string} screen - Pantalla
 * @param {Object} selectedOption - Opción seleccionada
 * @param {string} secondSelect - Segunda selección
 * @param {string} name - Nombre
 * @param {string} team - Equipo
 * @param {number} quantity - Cantidad
 * @param {string} Startime - Tiempo de inicio
 * @param {number} incidenciaCount - Contador de incidencias
 * @param {string} firstName - Primer nombre
 * @param {string} firstId - Primer ID
 * @param {number} peso - Peso
 * @param {string} FinishTime - Tiempo de finalización
 * @param {string} comentario - Comentario
 * @param {number} numImgLGD - Número de imagen LGD
 * @param {string} statusLGD - Estado LGD
 * @param {number} numImgCVD - Número de imagen CVD
 * @param {string} statusCVD - Estado CVD
 * @param {string} solucion - Solución
 * @returns {Promise<boolean>} true si se guardó correctamente, false en caso contrario
 */
export const updateTemp = async (
  po,
  mo,
  formattedTime,
  screen,
  selectedOption,
  secondSelect,
  name,
  team,
  quantity,
  Startime,
  incidenciaCount,
  firstName,
  firstId,
  peso,
  FinishTime,
  comentario,
  numImgLGD,
  statusLGD,
  numImgCVD,
  statusCVD,
  solucion
) => {
  const newTime = {
    po: po,
    mo: mo,
    usuario: name,
    team: team,
    tipo:
      team === "Control de calidad"
        ? selectedOption.name
        : screen === 8
        ? firstName
        : selectedOption,
    codigo:
      screen === 8
        ? firstId
        : screen === 9
        ? selectedOption[0]["id"]
        : selectedOption["id"],
    fecha_ini: Startime,
    fecha_fin: FinishTime,
    duracion: formattedTime,
    quantity: quantity,
    query_type: screen,
    incident: incidenciaCount,
    typeIncident: secondSelect,
    firstName: firstName,
    firstId: firstId,
    peso: peso,
    comentario: comentario,
    numImgLGD: numImgLGD,
    statusLGD: statusLGD,
    numImgCVD: numImgCVD,
    statusCVD: statusCVD,
    solucion: solucion,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Save");
      return true;
    } else {
      console.log("Error Save");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
